export class ListInstanceTypesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceTypes",
            "baseName": "instanceTypes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "instantRestoreMapping",
            "baseName": "instantRestoreMapping",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInstanceTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
